import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { fetchUserPreferences, setUserPreferencesFetchFailure, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/cover-page/cover-page.actions';
import { setHartfordCoverPageInfo } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/hartford-cover-page/hartford-cover-page.actions';
import { resetSelectedReport, setReportTitle, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { selectClient } from 'IntegrationsApp/ts/features/integrations-shared/state/hartford-import-holdings/actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { INTEGRATIONS_STATE_SLICE_KEY } from 'IntegrationsApp/ts/features/integrations-shared/state/integrations-shared.reducer';
import { getAllSecurities, getCurrentWizardStepIndex, getDefaultReportTitle, getSelectedReport, getWizardStepEventName, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { AS_OF_DATE_DROPDOWN_CONFIG, AS_OF_DATE_LATEST } from 'CustomPDFReportsApp/ts/constants';
import { REPORT_TITLE_MAX_LENGTH } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/constants';
import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { HartfordClientSearchModalComponent } from 'IntegrationsApp/ts/features/integrations-shared/components/hartford-import-holdings/search-modal/hartford-client-search-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "Angular/services/core/ajax.service";
import * as i3 from "Angular/services/core/urls.service";
import * as i4 from "@ngrx/store";
import * as i5 from "@angular/common";
import * as i6 from "@angular/forms";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i9 from "IntegrationsApp/ts/features/integrations-shared/components/hartford-import-holdings/search-modal/hartford-client-search-modal.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = a0 => ({ disabled: a0 });
function HartfordCoverPageModuleModalComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 3);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function HartfordCoverPageModuleModalComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Report title cannot exceed ", ctx_r1.REPORT_TITLE_MAX_LENGTH, " characters. ");
} }
function HartfordCoverPageModuleModalComponent_Conditional_16_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1, " The contact selected does not match the contact associated with one or more securities in the report. ");
    i0.ɵɵelementEnd();
} }
function HartfordCoverPageModuleModalComponent_Conditional_16_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "div", 37);
    i0.ɵɵlistener("click", function HartfordCoverPageModuleModalComponent_Conditional_16_Template_div_click_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.resetClient()); });
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 38);
    i0.ɵɵelementEnd()()();
    i0.ɵɵconditionalCreate(5, HartfordCoverPageModuleModalComponent_Conditional_16_Conditional_5_Template, 2, 0, "div", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.clientName, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-edit");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showClientMismatchWarning ? 5 : -1);
} }
function HartfordCoverPageModuleModalComponent_Conditional_17_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "input", 39);
    i0.ɵɵtwoWayListener("ngModelChange", function HartfordCoverPageModuleModalComponent_Conditional_17_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.clientSearchTerm, $event) || (ctx_r1.clientSearchTerm = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 40)(3, "div", 41);
    i0.ɵɵlistener("click", function HartfordCoverPageModuleModalComponent_Conditional_17_Template_div_click_3_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.searchModalHandler()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 38);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.clientSearchTerm);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-search");
} }
function HartfordCoverPageModuleModalComponent_Conditional_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Your firm has locked Performance/Risk Data As Of to ", ctx_r1.lockedAsOfDateOptionLabel, ". ");
} }
export class HartfordCoverPageModuleModalComponent {
    constructor(accountsService, ajaxService, urlsService, store, integrationsStore) {
        this.accountsService = accountsService;
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.store = store;
        this.integrationsStore = integrationsStore;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.USER = window.USER;
        this.DRAFT = CustomPDFReportDesignation.DRAFT;
        this.REPORT_TITLE_MAX_LENGTH = REPORT_TITLE_MAX_LENGTH;
        // Modal Info
        this.isOpen = false;
        this.isLoading = false;
        this.defaultReportTitle = '';
        this.clientSelected = false;
        this.currentWizardStepIndex = null;
        this.destroy$ = new Subject();
        this.searchModalOpen = false;
        this.showClientMismatchWarning = false;
        // Report Info
        this.reportTitle = null;
        this.designationTypeOption = CustomPDFReportDesignation.DELIVERABLE;
        this.asOfDateConfig = AS_OF_DATE_DROPDOWN_CONFIG;
        this.asOfDateOption = AS_OF_DATE_LATEST;
        // Set when the client group locks the as-of date option
        this.lockedAsOfDateOption = null;
        this.asOfDateCssConfig = {
            button: 'btn btn-secondary btn-block style-underline',
        };
        this.securityIds = [];
        // Hartford Specific Info
        this.clientSearchTerm = '';
        this.clientName = '';
        this.clientID = '';
        this.securityClientIDs = [];
        this.firmName = '';
        this.modelNames = [];
        this.mapStateToComponent = (customPDFReportState, integrationsState) => {
            this.integrationsState = integrationsState;
            this.updateClient(integrationsState.selectedClient);
            this.currentWizardStepIndex = getCurrentWizardStepIndex(customPDFReportState);
            this.defaultReportTitle = getDefaultReportTitle(customPDFReportState);
            this.securityIds = getAllSecurities(customPDFReportState)
                .map((security) => security.securityId)
                .filter((securityId) => !!securityId);
            if (this.reportTitle === null && this.isOpen) {
                this.reportTitle = customPDFReportState.reportTitle || this.defaultReportTitle;
            }
            const selectedReport = getSelectedReport(customPDFReportState);
            if (selectedReport &&
                !this.isOpen &&
                this.currentWizardStepIndex === 0 &&
                getWizardStepEventName(customPDFReportState) ===
                    CustomPDFReportModalEventName.SHOW_HARTFORD_COVER_PAGE_MODULE_MODAL) {
                this.openModal();
            }
        };
        this.storeSubscription = combineLatest([
            this.store.select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY),
            this.integrationsStore.select((state) => state[INTEGRATIONS_STATE_SLICE_KEY].hartfordImportHoldings),
        ]).subscribe(([customPDFReportState, integrationsState]) => this.mapStateToComponent(customPDFReportState, integrationsState));
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
    }
    resetInputFields() {
        this.asOfDateOption = this.lockedAsOfDateOption ?? AS_OF_DATE_LATEST;
        this.designationTypeOption = CustomPDFReportDesignation.DELIVERABLE;
        this.reportTitle = null;
    }
    resetClient() {
        this.clientSearchTerm = '';
        this.clientSelected = false;
        this.clientName = '';
        this.clientID = '';
        this.firmName = '';
        this.showClientMismatchWarning = false;
        this.integrationsStore.dispatch(selectClient({ selectedClient: null }));
    }
    closeModal() {
        this.isOpen = false;
        this.resetInputFields();
        this.resetClient();
    }
    openModal() {
        this.isLoading = true;
        this.isOpen = true;
        this.fetchUserPreferences();
        this.applyClientGroupPreferences();
        this.fetchHartfordData();
    }
    updateClient(hartfordClient) {
        if (hartfordClient) {
            this.clientSelected = true;
            this.clientName = hartfordClient.Name;
            this.clientID = hartfordClient.Id;
            this.firmName = hartfordClient.Firm || '';
            if (!this.isLoading) {
                this.updateShowClientMismatchWarning();
            }
            if (this.searchModalOpen) {
                this.closeSearchModal();
            }
        }
        else {
            this.clientSelected = false;
            this.clientName = '';
            this.clientID = '';
            this.firmName = '';
        }
    }
    updateShowClientMismatchWarning() {
        const mismatchedClientIDs = this.securityClientIDs.filter((id) => id !== this.clientID);
        this.showClientMismatchWarning = mismatchedClientIDs.length > 0;
    }
    // Input Handlers
    asOfDateHandler(value) {
        this.asOfDateOption = value;
    }
    designationTypeHandler(event) {
        const checkbox = event.target;
        this.designationTypeOption = checkbox.checked
            ? CustomPDFReportDesignation.DRAFT
            : CustomPDFReportDesignation.DELIVERABLE;
    }
    searchModalHandler() {
        if (this.clientSearchTerm) {
            this.searchModalOpen = true;
            this.hartfordClientSearchModalComponent.setSearchTerms(this.clientSearchTerm);
            this.hartfordClientSearchModalComponent.submit(1);
        }
    }
    closeSearchModal() {
        this.searchModalOpen = false;
    }
    // Wizard Step Handling
    get hasInvalidInput() {
        return this.reportTitle == null || !this.clientSelected;
    }
    back() {
        this.closeModal();
        if (this.currentWizardStepIndex) {
            this.store.dispatch(decrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
        else {
            this.store.dispatch(resetSelectedReport());
        }
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
    }
    proceedToNextStep() {
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
        this.closeModal();
    }
    forward() {
        if (this.hasInvalidInput)
            return;
        this.store.dispatch(setReportTitle({ title: this.reportTitle }));
        this.store.dispatch(setHartfordCoverPageInfo({
            asOfDateOption: this.asOfDateOption,
            designationType: this.designationTypeOption,
            clientID: this.clientID,
            clientName: this.clientName,
            firmName: this.firmName,
            modelNames: this.modelNames,
        }));
        this.proceedToNextStep();
    }
    // Data Fetching
    fetchUserPreferences() {
        this.store.dispatch(fetchUserPreferences());
        this.accountsService.getUserPreferences().subscribe({
            next: (preferences) => {
                if (preferences.default_report_designation) {
                    this.designationTypeOption = preferences.default_report_designation;
                }
            },
            error: () => {
                this.store.dispatch(setUserPreferencesFetchFailure());
            },
        });
    }
    applyClientGroupPreferences() {
        this.accountsService
            .getClientGroupPreferences()
            .subscribe(({ lock_report_as_of_date_option, report_as_of_date_option }) => {
            this.lockedAsOfDateOption =
                lock_report_as_of_date_option && report_as_of_date_option ? report_as_of_date_option : null;
            if (report_as_of_date_option) {
                this.asOfDateOption = report_as_of_date_option;
            }
        });
    }
    get lockedAsOfDateOptionLabel() {
        return this.asOfDateConfig.list.find((item) => item.value === this.lockedAsOfDateOption)?.label;
    }
    fetchHartfordData() {
        this.ajaxService
            .getDataObserveBody(this.urlsService.INTEGRATIONS.HARTFORD_DATA, {
            security_ids: this.securityIds.join(','),
        })
            .pipe(takeUntil(this.destroy$), finalize(() => {
            this.isLoading = false;
        }))
            .subscribe((response) => {
            this.modelNames = response.matrix_names;
            this.securityClientIDs = response.client_ids;
            this.isLoading = false;
            this.updateClient(this.integrationsState?.selectedClient ?? null);
        });
    }
}
HartfordCoverPageModuleModalComponent.ɵfac = function HartfordCoverPageModuleModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HartfordCoverPageModuleModalComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.AjaxService), i0.ɵɵdirectiveInject(i3.UrlsService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i4.Store)); };
HartfordCoverPageModuleModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HartfordCoverPageModuleModalComponent, selectors: [["ycn-hartford-cover-page-module-modal"]], viewQuery: function HartfordCoverPageModuleModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(HartfordClientSearchModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hartfordClientSearchModalComponent = _t.first);
    } }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 53, vars: 19, consts: [["helpModal", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [3, "loaderMessage"], [1, "modal-body"], [1, "modal-section"], [1, "mb-row", "text-bold"], [1, "mb-3"], [1, "form-label", "form-label-thin", "pb-1"], ["type", "text", "placeholder", "My Report Title", 1, "form-control", 3, "ngModelChange", "ngModel"], [1, "text-red", "text-smallest"], [1, "form-group-editable", "is-editing"], [1, "field-input-group", "field-search", "input-group"], [1, "row", "mb-3"], [1, "col-6"], [1, "dropdown", 3, "changeHandler", "config", "selectedValue", "customCssClasses", "inputDisabled"], [1, "text-smallest", "text-gray-40", "mt-1"], [1, "divider-horizontal"], [1, "modal-footer"], [1, "modal-footer-info", "align-self-start"], [1, "btn", "btn-text", 3, "click"], [1, "mt-1", "text-default"], [1, "custom-control", "custom-checkbox", "mr-0"], ["type", "checkbox", "name", "report-designation", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "help-toggler", 3, "click"], ["name", "print_as_draft"], [1, "ml-auto", "align-self-start"], [1, "modal-footer-actions", "justify-content-end"], [1, "btn", "btn-secondary", 3, "click"], [1, "btn", "btn-primary", 3, "click", "ngClass"], [1, "mt-1", "text-smallest", "ng-scope"], [3, "closeModalHandler", "open", "extraModalClasses"], [1, "modal-body", "pb-5"], [1, "modal-section", "mb-5"], [3, "modalOpen"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-edit", 3, "click"], ["ycnIcon", "", 3, "name"], ["placeholder", "Enter Name", 1, "form-control", "field-input", 3, "ngModelChange", "ngModel"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent", 3, "click"]], template: function HartfordCoverPageModuleModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function HartfordCoverPageModuleModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function HartfordCoverPageModuleModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(2, HartfordCoverPageModuleModalComponent_Conditional_2_Template, 1, 1, "ycn-loading-symbol", 3);
        i0.ɵɵelementStart(3, "div", 4)(4, "div", 5)(5, "div", 6);
        i0.ɵɵtext(6, "Basic Info");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 7)(8, "label", 8);
        i0.ɵɵtext(9, "Report Title");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "input", 9);
        i0.ɵɵtwoWayListener("ngModelChange", function HartfordCoverPageModuleModalComponent_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.reportTitle, $event) || (ctx.reportTitle = $event); return i0.ɵɵresetView($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(11, HartfordCoverPageModuleModalComponent_Conditional_11_Template, 2, 1, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 7)(13, "label", 8);
        i0.ɵɵtext(14, "Prepared For*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 11);
        i0.ɵɵconditionalCreate(16, HartfordCoverPageModuleModalComponent_Conditional_16_Template, 6, 3)(17, HartfordCoverPageModuleModalComponent_Conditional_17_Template, 5, 2, "div", 12);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(18, "div", 13)(19, "div", 14)(20, "label", 8);
        i0.ɵɵtext(21, "Performance/Risk Data As Of:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "ycn-single-select-dropdown", 15);
        i0.ɵɵlistener("changeHandler", function HartfordCoverPageModuleModalComponent_Template_ycn_single_select_dropdown_changeHandler_22_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.asOfDateHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(23, HartfordCoverPageModuleModalComponent_Conditional_23_Template, 2, 1, "div", 16);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(24, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 18)(26, "div", 19)(27, "div", 20);
        i0.ɵɵlistener("click", function HartfordCoverPageModuleModalComponent_Template_div_click_27_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵtext(28, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 21)(30, "label", 22)(31, "input", 23);
        i0.ɵɵlistener("change", function HartfordCoverPageModuleModalComponent_Template_input_change_31_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.designationTypeHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(32, "span", 24);
        i0.ɵɵelementStart(33, "span", 25);
        i0.ɵɵtext(34, "Print as Draft");
        i0.ɵɵelementEnd()();
        i0.ɵɵtext(35, " \u00A0 ");
        i0.ɵɵelementStart(36, "span", 26);
        i0.ɵɵlistener("click", function HartfordCoverPageModuleModalComponent_Template_span_click_36_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r5 = i0.ɵɵreference(39); return i0.ɵɵresetView(helpModal_r5.openModal("print_as_draft")); });
        i0.ɵɵtext(37, "(?)");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(38, "ycn-help-modal", 27, 0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(40, "div", 28)(41, "div", 29)(42, "div", 30);
        i0.ɵɵlistener("click", function HartfordCoverPageModuleModalComponent_Template_div_click_42_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.back()); });
        i0.ɵɵtext(43, "Back");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div", 31);
        i0.ɵɵlistener("click", function HartfordCoverPageModuleModalComponent_Template_div_click_44_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵtext(45, "Generate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(46, "div", 32);
        i0.ɵɵtext(47, "By clicking \u201Cgenerate\u201D, your report will download and sync to Salesforce. ");
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(48, "ycn-modal-base", 33);
        i0.ɵɵlistener("closeModalHandler", function HartfordCoverPageModuleModalComponent_Template_ycn_modal_base_closeModalHandler_48_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeSearchModal()); });
        i0.ɵɵelementStart(49, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function HartfordCoverPageModuleModalComponent_Template_ycn_simple_modal_header_closeModalHandler_49_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeSearchModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 34)(51, "div", 35);
        i0.ɵɵelement(52, "ycn-hartford-client-search-modal", 36);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Generate Report");
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isLoading ? 2 : -1);
        i0.ɵɵadvance(8);
        i0.ɵɵtwoWayProperty("ngModel", ctx.reportTitle);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.reportTitle && ctx.reportTitle.length >= ctx.REPORT_TITLE_MAX_LENGTH ? 11 : -1);
        i0.ɵɵadvance(5);
        i0.ɵɵconditional(ctx.clientSelected ? 16 : 17);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("config", ctx.asOfDateConfig)("selectedValue", ctx.asOfDateOption)("customCssClasses", ctx.asOfDateCssConfig)("inputDisabled", !!ctx.lockedAsOfDateOption);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.lockedAsOfDateOption ? 23 : -1);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("checked", ctx.designationTypeOption === ctx.DRAFT);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c0, ctx.hasInvalidInput));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("open", ctx.searchModalOpen)("extraModalClasses", "modal-lg");
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select a Hartford Client");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("modalOpen", ctx.searchModalOpen);
    } }, dependencies: [i5.NgClass, i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgModel, i7.HelpModalComponent, i8.IconDirective, i9.HartfordClientSearchModalComponent, i10.LoadingSymbolComponent, i11.ModalBaseComponent, i12.SimpleModalHeaderComponent, i13.SingleSelectDropdownComponent], encapsulation: 2 });
